import { NotificationConfiguration } from '../notification.templates';

export const MEETING_TODO_DUE_SOON_TEMPLATE: NotificationConfiguration = {
  inapp: `Your todo is pending until <b>{dueDate}</b>`,
  email: {
    ctaKey: 'go_to_todos',
  },
};
